module.exports = __webpack_public_path__ + "static/media/student-snapshort2-frame.907c1fde.png";